
import { Component, Input, OnInit, OnDestroy, EventEmitter, Output } from '@angular/core';
import { environment } from '@environments/environment';
import { FeaturesMap, Flight } from '@ibe.models/flight.model.lib';
import { PassengerFlightInfo } from '@ibe.models/passenger-flight-info.model';
import { Store } from '@ngrx/store';
import * as fromStore from '@ibe/store/index';
import { BookedTrip } from '@ibe.models/booked-trip.model.lib';
import { Observable, Subscription } from 'rxjs';
import { takeWhile } from 'rxjs/operators';
import { packFeature } from '@ibe.components/booking/flights/brand/brand.indra';
import { INDRABFMDataStorageService } from '@ibe.services/bfm-data-storage.indra.service';
import { INDRAFeature } from '@ibe.components/shared/flight-brand-features-list/features.indra';
import { INDRAAncillariesService } from '@ibe.services/ancillaries.indra.service';
import { INDRAIbeAdminService } from '@ibe.services/ibeadmin.indra.service';
import { INDRAPackService } from '@ibe.components/shared/sidebar-views/ancillaries/pack/pack.service.indra';
import { INDRABookingService } from '@ibe.services/booking.indra.service';
import { INDRAAncillariesSelectionService } from '@ibe.services/ancillaries-selection.indra.service';
import { INDRAAncillariesShoppingCartService } from '@ibe.services/ancillaries-shopping-cart.indra.service';
import { INDRABookingSearchService } from '@ibe.services/booking-search.indra.service';
import { INDRAStorageService } from '@ibe.services/storage.indra.service';
import { PaymentService } from '@ibe.components/shared/payment/payment.service';
import { INDRATotalFlightPrice } from '@ibe.models/flight-price.model.indra.lib';
import { INDRABookedTripDetails } from '@ibe.models/booked-trip-details.indra.model.lib';
import { EXTRAS_ANCILLARY_EQUIPMENT, EXTRAS_ANCILLARY_MUSICAL, TRANSLATION_ANCILLARY_DETAILED } from '@ibe.config';

@Component({
    selector: 'app-bundle-card',
    templateUrl: './bundle-card.indra.component.html',
    styleUrls: ['./bundle-card.component.scss']
})
export class INDRABundleCardComponent implements OnInit, OnDestroy {

    isAlive = true;
    otherFlights: Flight[] = [];

    booking$: Observable<BookedTrip> = this.store.select(fromStore.getSelectedBookedTrip);
    booking: BookedTrip;

    @Input()
    pack: any;

    @Input()
    disable: boolean;

    @Input()
    bound: any

    @Input()
    fromModal: boolean = false;

    @Output()
    add = new EventEmitter();

    @Output()
    remove = new EventEmitter();

    activeBookedTrip: INDRABookedTripDetails = null;
	itemsCurrencyCode: string;
    added: boolean = false;
    passengers: any;

    packSubscription: Subscription;

    flightBased: boolean = false;

    constructor(
        private store: Store<fromStore.State>,
		private bfmStorage: INDRABFMDataStorageService,
		private ancillariesService: INDRAAncillariesService,
		protected ibeAdminService: INDRAIbeAdminService,
        private packService: INDRAPackService,
		protected bookingService: INDRABookingService,
		protected ancillariesSelectionSrv: INDRAAncillariesSelectionService,
		protected ancillariesShoppingCartSrv: INDRAAncillariesShoppingCartService,
		private bookingSearchService: INDRABookingSearchService,
		protected storageService: INDRAStorageService,
		protected paymentInfoService: PaymentService
    ) {
    }

    ngOnInit(): void {
        this.activeBookedTrip = this.bfmStorage.INDRA_getActiveBookedTrip();
        if (this.activeBookedTrip['ancillaries-data']) {
			this.itemsCurrencyCode = this.activeBookedTrip['ancillaries-data']['bundleList'].filter(bundle => bundle.ancillaryList.length && bundle.ancillaryList[0].catalog)[0].ancillaryList[0].catalog[0].passengers[0].codeList[0].currency;
		}
        this.passengers = this.bookingService.INDRA_getPaxInfo(false);
        this.packSubscription = this.packService.currentPacks.subscribe(value => {
            if (value.length > 0) {
                value.forEach(pck => {
                    if (this.bound.details.idFlight == pck.flightId && pck.passengers[0].codeList[0].code == this.pack[0].passengers[0].codeList[0].code) {
                        this.added = true;
                    }
                });
            }
        });
        this.flightBased = this.pack.some(pack => pack.flightBased);
    }

    INDRA_getAndFormatCash() {
        let lowestPrice = 0;
        this.pack.forEach((pack) => {
            const price = parseFloat(pack.passengers[0].codeList[0].price);
            if (!isNaN(price) && (lowestPrice > price || lowestPrice === 0)) {
                lowestPrice = price;
            }
        })
        return lowestPrice === 0 ? 0: lowestPrice.toFixed(2);
    }

    INDRA_getFeatureCount() {
        let count = 0;
        let features = this.INDRA_getPackFeatures(this.pack);
        if (features && features.length) {
            count = features.length;
        }

        return count;
    }

    INDRA_handleOpenPack() {
        this.add.emit(this.pack);
    }

	INDRA_removeBundle() {
        this.added = false;
		let pnr = this.bookingService.getCurrentPNR();
        let removedAncillaries = [];
        let addedAncillaries = this.ancillariesShoppingCartSrv.INDRA_getAddedAncillaries();

        this.ancillariesSelectionSrv.INDRA_doBundleDeletion(this.pack, pnr, this.passengers, this.bound.details.listSegment, addedAncillaries).subscribe(result => {
            if (result.status == "200") {
                this.pack.forEach(segmentPack => {

                    this.packService.removePack(segmentPack);
                    this.packService.selectSeats({})
                    segmentPack.passengers.forEach((passenger, index) => {
                        let addedPack = addedAncillaries.find(anc => anc.flightId.toString() === segmentPack.flightId.toString() && anc.segmentId.toString() === segmentPack.segmentId.toString() && anc.code === segmentPack.type)
                        if (addedPack) {
                            let packAsAncillary: any = {
                                code: passenger.codeList[0].code,
                                currency: passenger.codeList[0].currency,
                                maxQuantity: 1,
                                price: passenger.codeList[0].price,
                                itemId: segmentPack.itemId,
                                type: passenger.codeList[0].type,
                                flightId:segmentPack.flightId,
                                flightCardId: segmentPack.flightId.toString(),
                                segmentId: segmentPack.segmentId,
                                flightBased: segmentPack.flightBased,
                                paxId: passenger.paxId,
                                paxTatto: passenger.paxTattoo,
                                enabled: true,
                                serviceCode: passenger.codeList[0].serviceCode
                            };

                            removedAncillaries.push(packAsAncillary)
                        }
                    });
                    this.storageService.set('INDRAAncillariesShoppingCartService.shoppingCart', removedAncillaries);
                    this.ancillariesShoppingCartSrv.INDRA_deleteAncillaries(removedAncillaries);
                });
                    this.bookingSearchService.INDRA_generateTemporaryPNR().subscribe(res => {
                        this.storageService.set('hasLoadedGenerate', true);
                        if (res && res.data) {
                            this.activeBookedTrip = new INDRABookedTripDetails(res);
                            this.INDRA_setBookingTotalCost();
                        }
                });
            }
        });
	}

    // set booking total cost
	INDRA_setBookingTotalCost() {
		if (this.activeBookedTrip.data.fare.bookingTotal) {
			let miles = this.activeBookedTrip.data.fare.bookingTotal.miles && this.activeBookedTrip.data.fare.bookingTotal.miles > 0 ? this.activeBookedTrip.data.fare.bookingTotal.miles : 0;
			let cash = this.activeBookedTrip.data.fare.bookingTotal.amount ? this.activeBookedTrip.data.fare.bookingTotal.amount : 0;

			const totalPrice: INDRATotalFlightPrice = {
				cash: cash,
				miles: miles,
				currency: this.activeBookedTrip.data.fare.bookingTotal.currency
			}
			this.paymentInfoService.setTotalFlightPrice(totalPrice);
		}
	}

    ngOnDestroy(): void {
        this.isAlive = false;
    }

    // Packs apply for all passengers in the flight
    INDRA_getPackFeatures(pack) {
        if (pack && pack.length) {
            return pack[0].passengers[0].codeList[0].ancillaryPackInfo.ancillaryDescription;
        }
    }

    INDRA_getPackName(pack) {
        return pack.freeText;
    }

    INDRA_getFeatureIcon(feature) {
        return INDRAFeature.createByCode(feature.code, true).icon;
    }

    INDRA_getFeatureLabel(feature) {
        if ([EXTRAS_ANCILLARY_EQUIPMENT, EXTRAS_ANCILLARY_MUSICAL].includes(feature.type)) {
            let equipmentTranslation = TRANSLATION_ANCILLARY_DETAILED + feature.code;
            return this.INDRA_getTranslation(equipmentTranslation);
        }
        return this.INDRA_getTranslation(this.ancillariesService.INDRA_getAncillaryConfig(feature.type).translation);
    }

    INDRA_getTranslation(key: string): string {
		return this.ibeAdminService.getTranslationValue(key);
	}
}
